import { escapeRegExp } from '../md-utils';

export const MENTIONS_MAP = [
    {
        id: 'user',
        symbol: '@'
    },
    {
        id: 'discussion',
        symbol: '!'
    },
    {
        id: 'project',
        symbol: '#'
    },
    {
        id: 'taskgroup',
        symbol: '??'
    },
    {
        id: 'task',
        symbol: '?'
    },
    {
        id: 'milestone',
        symbol: '^'
    },
    {
        id: 'label',
        symbol: '~'
    },
    {
        id: 'subteam',
        symbol: '$'
    }
];

const createRule = (md, scanRE, replaceRE) => {
    const arrayReplaceAt = md.utils.arrayReplaceAt;
    const ucm = md.utils.lib.ucmicro;

    const splitTextToken = (text, level, Token) => {
        const nodes = [];
        let lastPos = 0;
        let token;

        text.replace(replaceRE, (match, mentionSymbol, mentionId, offset, src) => {
            let mentionName;

            const mention = getMentionBySymbol(mentionSymbol);

            if (mention) {
                // replace shortcut with full name
                mentionName = mention.id;
            } else {
                mentionName = match.slice(1, -1);
            }

            // Add new tokens to pending list
            if (offset > lastPos) {
                token = new Token('text', '', 0);
                token.content = text.slice(lastPos, offset);
                nodes.push(token);
            }

            token = new Token('mention', '', 0);
            token.attrs = [
                ['id', mentionId],
                ['type', mentionName]
            ];

            token.content = ''; // set content
            nodes.push(token);

            lastPos = offset + match.length;

        });

        if (lastPos < text.length) {
            token = new Token('text', '', 0);
            token.content = text.slice(lastPos);
            nodes.push(token);
        }

        return nodes;
    }

    return state => {
        var i, j, l, tokens, token,
                blockTokens = state.tokens,
                autolinkLevel = 0;

        for (j = 0, l = blockTokens.length; j < l; j++) {
            if (blockTokens[j].type !== 'inline') { continue; }
            tokens = blockTokens[j].children;

            // We scan from the end, to keep position when new tags added.
            // Use reversed logic in links start/end match
            for (i = tokens.length - 1; i >= 0; i--) {
                token = tokens[i];

                if (token.type === 'link_open' || token.type === 'link_close') {
                    if (token.info === 'auto') { autolinkLevel -= token.nesting; }
                }

                if (token.type === 'text' && autolinkLevel === 0 && scanRE.test(token.content)) {
                    // replace current node
                    blockTokens[j].children = tokens = arrayReplaceAt(
                        tokens, i, splitTextToken(token.content, token.level, state.Token)
                    );
                }
            }
        }
    };
};

export const getMentionBySymbol = mentionSymbol => MENTIONS_MAP.find(({ symbol }) => symbol === mentionSymbol);
export const getMentionById = mentionId => MENTIONS_MAP.find(({ id }) => id === mentionId);

const mentions = MENTIONS_MAP.map(({ symbol }) => escapeRegExp(symbol)).join('|');
export const mentionRegex = `<(${mentions})([0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_!]{7,20})?>`;

export default function plugin(md, options) {
    md.core.ruler.push('mention', createRule(md, RegExp(mentionRegex), RegExp(mentionRegex, 'g')));
};
